import React from 'react';
import classNames from 'classnames';

import Button from 'rebook/apps/base/components/Button';
import AppButton from 'rebook/apps/base/components/AppButton';
import numberWithSpace from 'rebook/apps/utils/text/numberWithSpace';
import pluralize from 'rebook/apps/utils/text/pluralize';
import { URLS } from 'rebook/apps/base/constants';

import styles from './style.scss';


const TopBlock = ({ audioBooksCounter, totalBooksCounter }) => (
  <div className={styles.header}>
    <div className={styles.titleBlock}>
      <div className={styles.picture} />
      <div className={styles.title}>
        <h1>
          MyBook –<br className={styles.breakMobile} /> читайте <br className={styles.breakFull} />и слушайте по
          <br className={styles.breakTablet} /> одной подписке
        </h1>
      </div>
      <ul className={styles.featureList}>
        <li className={styles.featureItem}>
          <i className={styles.booksIcon} />
          <span className={styles.featureText}>
            <b>{numberWithSpace(totalBooksCounter)}</b>{' '}<br className={styles.breakFeature} />
            {pluralize(totalBooksCounter, 'книга', 'книги', 'книг')}
          </span>
        </li>
        <li className={styles.featureItem}>
          <i className={styles.audioBooksIcon} />
          <span className={styles.featureText}>
            <b>{numberWithSpace(audioBooksCounter)}</b>{' '}<br className={styles.breakFeature} />
            {pluralize(audioBooksCounter, 'аудиокнига', 'аудиокниги', 'аудиокниг')}
          </span>
        </li>
        <li className={styles.featureItem}>
          <i className={styles.starIcon} />
          <span className={styles.featureText}>
            <b>+ 2 000</b> новинок<br className={styles.breakFeature} /> каждый месяц
          </span>
        </li>
        <li className={styles.featureItem}>
          <i className={styles.puzzleIcon} />
          <span className={styles.featureText}>
            <b>Подборки</b><br className={styles.breakFeature} /> и&nbsp;рекомендации
          </span>
        </li>
        <li className={styles.featureItem}>
          <i className={styles.offlineIcon} />
          <span className={styles.featureText}>
            <b>Офлайн</b><br className={styles.breakFeature} /> или онлайн
          </span>
        </li>
      </ul>
      <div className={styles.buttonList}>
        <Button
          link={`${URLS.trialCard}?from=main_top`}
          theme="advert"
          handeClick={() => { ga('send', 'event', 'Offer', 'PushButton', 'LandingTop'); }}
          extraClassName={classNames('jest-week-trial-link', styles.trialButton)}>
          <span>14 дней бесплатно</span>
        </Button>
        <AppButton target="landing_top" extraClassName={styles.appButton} />
      </div>
    </div>
  </div>
);

export default TopBlock;
